import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Col,
  Form,
  Row,
  Spinner,
} from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";

import CustomNavbar from "../../../../components/CustomNavbar";
import SidebarConfig from "../../../../components/Clima/SidebarClimate";
import CampoPreguntaEncuesta from "../../../../components/Clima/EncuestaPlantilla/pregunta";
import { getPlantillaCuestionariosById } from "../../../../redux/climalaboral/plantillaCuestionario/action";

const PlantillasVisualización = (props) => {
  const [show, setShow] = useState(false);
  const [plantilla, setPlantilla] = useState(null);

  const dispatch = useDispatch();
  const history = useHistory();

  const { surveyLoading } = useSelector((store) => store.plantillaCuestionario);

  useEffect(() => {
    dispatch(
      getPlantillaCuestionariosById(
        parseInt(props.match.params.id),
        setPlantilla
      )
    );
  }, [props.match.params.id]);

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarConfig show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div>
            <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
              <h6 className="m-0 font-weight-bold text-uppercase d-flex justify-content-between align-items-center">
                Cuestionario
              </h6>
              <Form>
                <Row className="justify-content-end align-items-center flex-nowrap">
                  <Col xs="auto">
                    <Row className="flex-wrap justify-content-center align-items-center">
                      <ButtonGroup className="flex-wrap justify-content-center align-items-center">
                        <Link
                          as="button"
                          variant="light"
                          className="btn roundend-circle"
                          to={
                            "/cuestionario/" +
                            props.match.params.id +
                            "/" +
                            props.match.params.Name +
                            "/"
                          }
                          onClick={() =>
                            history.push(
                              "/cuestionario/" +
                                props.match.params.id +
                                "/" +
                                props.match.params.Name +
                                "/"
                            )
                          }
                        >
                          <i className="material-icons">visibility_off</i>
                        </Link>
                      </ButtonGroup>
                    </Row>
                  </Col>
                </Row>
              </Form>
            </div>
            <div className="px-2">
              <hr />
            </div>
          </div>
          {surveyLoading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            <>
              {plantilla && (
                <Container fluid>
                  <div
                    className="
                      flex-wrap
                      justify-content-center
                      align-items-center
                      p-3
                      mb-5"
                    // bg-white
                  >
                    <Row>
                      <Col
                        xs="10"
                        sm="10"
                        md="9"
                        lg="9"
                        xl="9"
                        style={{ margin: "auto" }}
                      >
                        <Row>
                          <Col md="12" className="ml-auto mr-auto">
                            <Form.Group
                              className="shadow-sm mb-5 bg-white rounded"
                              style={{ border: "0.1px solid #ced4da" }}
                            >
                              <div className="estiloFondo">
                                <div className="b pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-center align-items-center">
                                  <Button
                                    size="sm"
                                    className="btn rounded-circle"
                                    disabled
                                  >
                                    <i
                                      className="material-icons"
                                      style={{ transform: "rotate(90deg)" }}
                                    >
                                      drag_indicator
                                    </i>
                                  </Button>
                                </div>
                              </div>
                              <div className="pl-3 pr-3 pb-3 mt-3">
                                <Form>
                                  <Row>
                                    <Form.Group as={Col} className="mb-3">
                                      <Col
                                        className="p-3 shadow-sm d-flex flex-wrap justify-content-between align-items-center rounded"
                                        style={{
                                          borderBottom: "0.1px solid #ced4da",
                                        }}
                                        sm="12"
                                        md="12"
                                        lg="12"
                                        xl="12"
                                      >
                                        <h6 className="m-0">
                                          {plantilla ? plantilla.nombre : null}
                                        </h6>
                                      </Col>
                                    </Form.Group>
                                  </Row>
                                  <Row>
                                    <Form.Group as={Col} className="mb-3">
                                      <Col
                                        className="p-3 shadow-sm d-flex flex-wrap justify-content-between align-items-center rounded"
                                        style={{
                                          borderBottom: "0.11px solid #ced4da",
                                        }}
                                        sm="12"
                                        md="12"
                                        lg="12"
                                        xl="12"
                                      >
                                        <h6 className="m-0">
                                          {plantilla
                                            ? plantilla.descripcion
                                            : null}
                                        </h6>
                                      </Col>
                                    </Form.Group>
                                  </Row>
                                </Form>
                              </div>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Row className="ml-auto mr-auto">
                          <Col md="12">
                            <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
                              <h6 className="font-weight-bold text-uppercase">
                                Preguntas
                              </h6>
                            </div>
                            <div className="px-2">
                              <hr />
                            </div>
                          </Col>
                        </Row>
                        {plantilla.list_preguntas.length === 0 ? (
                          <Alert className="my-4" variant="info">
                            Aún no hay preguntas registradas, comience agregando
                            algunas.
                          </Alert>
                        ) : (
                          <>
                            <Row>
                              <Col md="12" className="ml-auto mr-auto">
                                {plantilla.list_preguntas
                                  .sort((a, b) => {
                                    if (
                                      a.posicion !== null &&
                                      b.posicion !== null
                                    ) {
                                      if (
                                        parseInt(a.posicion) ===
                                          parseInt(b.posicion) &&
                                        a.id > b.id
                                      ) {
                                        return 1;
                                      }

                                      if (
                                        parseInt(a.posicion) ===
                                          parseInt(b.posicion) &&
                                        a.id < b.id
                                      ) {
                                        return -1;
                                      }

                                      if (
                                        parseInt(a.posicion) <
                                        parseInt(b.posicion)
                                      ) {
                                        return -1;
                                      }
                                    }
                                    if (a.id > b.id) {
                                      return 1;
                                    }
                                    if (a.id < b.id) {
                                      return -1;
                                    }
                                  })
                                  .map((item, index) => (
                                    <div key={item.id}>
                                      <CampoPreguntaEncuesta
                                        pregunta={item}
                                        index={index}
                                      />
                                    </div>
                                  ))}
                              </Col>
                            </Row>
                          </>
                        )}
                      </Col>
                      <Col
                        xs="1"
                        sm="1"
                        md="1"
                        lg="1"
                        xl="1"
                        className="ml-auto mr-auto"
                        style={{
                          padding: "0",
                          position: "fixed",
                          right: "2rem",
                        }}
                      ></Col>
                    </Row>
                  </div>
                </Container>
              )}
            </>
          )}
        </Container>
      </div>
    </>
  );
};

export default PlantillasVisualización;
